var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{staticClass:"mb-5 table-dropdown no-scrollbar border rounded",attrs:{"empty-text":_vm.$t('there_are_no_records'),"bordered":"","striped":"","responsive":"","items":_vm.items,"fields":_vm.fields,"show-empty":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }